import React from 'react'
import PropTypes from 'prop-types'
import { AppBar, Toolbar, Typography, Box, FormControl, Select, MenuItem, Button, Divider } from '../../../../components/mui/Core/index'
import FilterListIcon from '@mui/icons-material/FilterList'
import { MOCK_ROLES } from '../../../../constants/hold-allocation-constants'
import { clientOrganizations } from '../../../../constants/client-orgranizations'

function HoldAllocationNav({ mockRole, onRoleChange, mockOrg, onOrgChange }) {
  const dmsOrgs = clientOrganizations.filter((c) => c.dmsFlag === 'Y')
  return (
    <AppBar position='static' sx={{ backgroundColor: '#145a4b', mb: 0 }}>
      <Toolbar sx={{ justifyContent: 'space-between', minHeight: '56px !important' }}>
        {/* Left: logo + title */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography
            variant='h6'
            sx={{
              fontFamily: 'SanomatMedium',
              fontSize: '1.1rem',
              color: '#ffffff',
              letterSpacing: 0.5,
            }}
          >
            LSL
          </Typography>
          <Divider orientation='vertical' flexItem sx={{ bgcolor: 'rgba(255,255,255,0.3)', mx: 1 }} />
          <Typography
            variant='h6'
            sx={{
              fontFamily: 'AtlasGroteskRegular',
              fontSize: '0.95rem',
              color: 'rgba(255,255,255,0.9)',
            }}
          >
            Hold &amp; Allocation
          </Typography>
        </Box>

        {/* Right: mock role + org selectors */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Org selector */}
          <Typography
            sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.8rem', fontFamily: 'AtlasGroteskRegular' }}
          >
            Org:
          </Typography>
          <FormControl size='small' variant='outlined' sx={{ minWidth: 150 }}>
            <Select
              value={mockOrg || ''}
              onChange={(e) => onOrgChange(e.target.value)}
              displayEmpty
              sx={{
                color: '#ffffff',
                fontSize: '0.85rem',
                fontFamily: 'AtlasGroteskRegular',
                '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.4)' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.8)' },
                '.MuiSvgIcon-root': { color: '#ffffff' },
              }}
            >
              <MenuItem value="" sx={{ fontFamily: 'AtlasGroteskRegular', fontSize: '0.85rem' }}>
                All Orgs
              </MenuItem>
              {dmsOrgs.map((c) => (
                <MenuItem key={c.clientCode} value={c.clientCode} sx={{ fontFamily: 'AtlasGroteskRegular', fontSize: '0.85rem' }}>
                  {c.clientCode} - {c.clientName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FilterListIcon sx={{ color: 'rgba(255,255,255,0.7)', fontSize: 18 }} />
          <Typography
            sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.8rem', fontFamily: 'AtlasGroteskRegular' }}
          >
            Demo Role:
          </Typography>
          <FormControl size='small' variant='outlined' sx={{ minWidth: 170 }}>
            <Select
              value={mockRole}
              onChange={(e) => onRoleChange(e.target.value)}
              sx={{
                color: '#ffffff',
                fontSize: '0.85rem',
                fontFamily: 'AtlasGroteskRegular',
                '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.4)' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.8)' },
                '.MuiSvgIcon-root': { color: '#ffffff' },
              }}
            >
              {MOCK_ROLES.map((r) => (
                <MenuItem key={r.value} value={r.value} sx={{ fontFamily: 'AtlasGroteskRegular', fontSize: '0.85rem' }}>
                  {r.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            size='small'
            variant='outlined'
            href='/hold-allocation'
            sx={{
              color: '#ffffff',
              borderColor: 'rgba(255,255,255,0.5)',
              fontSize: '0.75rem',
              fontFamily: 'AtlasGroteskRegular',
              textTransform: 'none',
              ml: 1,
              '&:hover': { borderColor: '#ffffff', backgroundColor: 'rgba(255,255,255,0.1)' },
            }}
          >
            Orders
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

HoldAllocationNav.propTypes = {
  mockRole: PropTypes.string.isRequired,
  onRoleChange: PropTypes.func.isRequired,
  mockOrg: PropTypes.string,
  onOrgChange: PropTypes.func.isRequired,
}

export default HoldAllocationNav
